/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_PolishInputs */

const en_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polish`)
};

const fr_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polonais`)
};

const de_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polieren`)
};

const it_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polacco`)
};

const ru_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`польский`)
};

const es_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polaco`)
};

const zh_cn2_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抛光`)
};

const ja_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`研磨`)
};

const hi_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पोलिश`)
};

const pt_pt2_speechmatics_target_language_polish = /** @type {(inputs: Speechmatics_Target_Language_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`polonês`)
};

/**
* | output |
* | --- |
* | "Polish" |
*
* @param {Speechmatics_Target_Language_PolishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_polish = /** @type {((inputs?: Speechmatics_Target_Language_PolishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_PolishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_polish(inputs)
	if (locale === "de") return de_speechmatics_target_language_polish(inputs)
	if (locale === "it") return it_speechmatics_target_language_polish(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_polish(inputs)
	if (locale === "es") return es_speechmatics_target_language_polish(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_polish(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_polish(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_polish(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_polish(inputs)
	return en_speechmatics_target_language_polish(inputs)
});